import Currencies from './Constants/Currencies'
import CUSTOM_INPUTS from './Constants/CustomInputs'
import CONDITIONAL_DISPLAY from './Constants/ConditionalDisplay'
import TRANSLATION_NS from './Constants/TranslationNS'
import * as CUSTOM_NOTES from './Constants/CustomNotes'
import TIMEZONE_NAMES from './Constants/TimezonesNames'
import CoefUpdateCompetitions from './Constants/CoefUpdateCompetitions'

export const Constants = {
    ORDER: {
        STATE_BOOKED: 'booked',
        STATE_CANCELED: 'canceled',
        TAG_FROM_RSNATCH: 'rsnatch.com',
        TAG_PROMO: 'code',
        TAG_DONATION: 'donation',
        CHECK_IN: {
            STATES: {
                PENDING: 'pending',
                CHECKED_IN: 'checked in',
                ABSENT: 'absent',
            },
        },
    },
    QUALIFICATION_STATE: {
        WAITING: 'waiting',
        QUALIFIED: 'qualified',
        REGISTERED: 'registered',
        DISQUALIFIED: 'disqualified',
    },
    REGISTRATION_MIN_COST: 0.1,
    SPECTATORS: {
        MAX_TICKETS_PER_ORDER: 20,
        MAX_PRODUCTS_PER_ORDER: 40,
        RESERVATION_DURATION_MINUTES: 10,
    },
    COEF_UPDATE_COMPETITIONS: CoefUpdateCompetitions.COEF_UPDATE_COMPETITIONS,
    COEF_UPDATE_FUTURE_COMPETITIONS: CoefUpdateCompetitions.COEF_UPDATE_FUTURE_COMPETITIONS,
    VALMEIMIER_THROWDOWN: CoefUpdateCompetitions.VALMEIMIER_THROWDOWN,
    DIVISION: {
        MAX_TEAM_LENGTH: 10,
    },
    CURRENCIES: Currencies,
    CUSTOM_INPUTS,
    CUSTOM_NOTES,
    COMPETITION_STATUS: {
        IN_PROGRESS: {
            key: 'IN_PROGRESS',
            label: 'IN PROGRESS',
            color: '#66d866',
        },
        FINISH: { key: 'FINISH', label: 'FINISH', color: '#e06363' },
        TO_COME_UP: {
            key: 'TO_COME_UP',
            label: 'TO COME UP',
            color: '#ff8952',
        },
    },
    CONDITIONAL_DISPLAY,
    TRANSLATION_NS,
    TIMEZONE_NAMES,
    EVENT: {
        CATEGORIES: ['Functional Fitness', 'Hybrid Race', 'Workshop'],
        PERIODS: ['live/future', 'past'],
    },
    UPLOAD: {
        LOGO_SIZE_LIMIT: 1 * 1024 * 1024, // 1MB
        FILE_SIZE_LIMIT: 2 * 1024 * 1024, // 2MB
        ALBUM_FILE_SIZE_LIMIT: 5 * 1024 * 1024, // 5MB
        GOODY_FILE_SIZE_LIMIT: 5 * 1024 * 1024, // 5MB per product photo
        GOODY_MAX_IMAGES: 5,
        MAX_UPLOAD_AT_A_TIME: 2000,
        MAX_UPLOAD_PER_WOD: 50,
        BATCH_SIZE: 10,
    },
    CATEGORY_OPTIONS: [
        { value: 'FRANCE', label: 'FRANCE', tva: 20, isDefault: true },
        { value: 'DOM TOM', label: 'DOM TOM', tva: 8.5 },
        { value: 'UE', label: 'UE', tva: 0 },
        { value: 'HORS UE', label: 'HORS UE', tva: 0 },
        { value: 'DOM TOM 0%', label: 'DOM TOM', tva: 0 },
        { value: 'NOT CATEGORIZED', label: 'NOT CATEGORIZED', tva: 0 },
    ],
    EVENT_PAGE_REVIEWS_LIMIT: 10,
    GOODIE_DEFAULT_FEES: {
        personalized: true,
        percentage: 5,
        fixed: 0,
    },
    CATEGORY: {
        HYBRID_RACE: 'Hybrid Race',
    },
    // TODO: replace with ticketing property in the future
    AUTO_GENERATE_TEAM_NAME_COMPETITIONS_IDS: [
        '68ff6fd8eea6f40033900ce9', // 2717 - HYROX by AGORA V2
        '693198471c811a0033dc96cf', // 2810 - HERMES - Olympium - Hyrox Championship Simulation (by Neo)
        '696103d846bc770033752dd2', // 2895 - HYROX by AGORA V3
        '693567ba1f7bc10033c630b3', // 2817 - HERACLES - Olympium - Hyrox Championship Simulation (by Neo)
        '69356cb01f7bc10033c6674c', // 2818 - ATHENA - Olympium - Hyrox Championship Simulation (by Neo)
    ],
    // TODO: make feature public in the future
    ACCESS_TO_CSV_SCORES_IMPORT_COMPETITIONS_IDS: [
        '68ff6fd8eea6f40033900ce9', // 2717 - HYROX by AGORA V2
        '69515bfbbd21340033d111fe', // 2864 - Keraqua Hyrox Challenge
        '68d161885075a60033234f70', // 2656 - CFSN HYBRID CHALLENGE 2026
        '6984bba4e796d2003305ddbf', // 2983 - HYROX Simulation Châteauroux by PR
        '6982261de4026e003375528e', // 2976 - HYROX BY TTP TRAINING (SPRING ÉDITION)
        '696103d846bc770033752dd2', // 2895 - HYROX by AGORA V3
        '6993190b2a81c30033094bbf', // 3017 - HYROX by Hybrid Athletics
    ],
    CUSTOM_INPUTS_WITH_20_CHAR_LIMIT_IDS: ['6a0c838ff4a95ecb69c39c80', '6a0c838ff4a95ecb69c39c81'], //2730 VALMEINIER THROWDOWN 2026
    ROLE: {
        ATHLETE: 'athlete',
        ORGA: 'orga',
        JUDGE: 'judge',
    },
    RICH_TEXT_EDITOR_IMAGE_TARGETS: {
        EVENT_DESCRIPTION: 'description',
        EVENT_DIVISION_DESCRIPTION: 'division-description',
        EVENT_WOD_DESCRIPTION: 'wod-description',
        EMAILING_DESCRIPTION: 'emailing-description',
        CONTRACT_DESCRIPTION: 'contract-description',
        TERMS_DESCRIPTION: 'terms-description',
    },
    // custom golden card events
    BLACK_BOX_COMPETITIONS_IDS: ['66bc5ea9c0286000339da239', '689b0e48ca35810033af2f98'],
    DEFAULT_PHONE: {
        code: 33,
        phone: '',
        short: 'FR',
    },
}
